import { useEffect, useState } from "react";

const NAV_LINKS = [
  { href: "#home", label: "首页" },
  { href: "#channels", label: "爆料入口" },
  { href: "#reports", label: "深度报道" },
  { href: "#protect", label: "保护指引" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-background-50/90 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 md:px-6">
        <a href="#home" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-flashlight-fill text-lg" aria-hidden="true"></i>
          </span>
          <span className="font-display text-xl font-bold tracking-tight text-foreground-900">
            今日<span className="text-primary-600">爆料</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#channels"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            我要爆料
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 md:hidden"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#channels"
              onClick={() => setOpen(false)}
              className="mt-1 whitespace-nowrap rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm font-medium text-background-50"
            >
              我要爆料
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}